import { gql } from 'graphql-tag'

export const SEND_BOOKINGS_MAGIC_LINK = gql`
  mutation sendMagicLink($input: String!) {
    sendMagicLink(email: $input)
  }
`

export const GET_BOOKINGS = gql`
  query getBookingsWithToken($token: String!) {
    bookingsWithToken(token: $token) {
      bookingDate
      checkInDate
      checkOutDate
      currency
      hotelName
      hotelId
      price
      status
      token
    }
  }
`
